import {connect} from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import MultiSelect from '../forms/MultiSelect';
import {UI} from '../';
import * as Api from 'api';
import * as Actions from 'actions';

class CategoryPanel extends React.Component {
    constructor(props) {
        super(props);
        this.add = this.add.bind(this);
        this.remove = this.remove.bind(this);
        this.handleNewCategoryChange = this.handleNewCategoryChange.bind(this);
        this.handleAddCategory = this.handleAddCategory.bind(this);
        this.handleCreateCategory = this.handleCreateCategory.bind(this);
        this.handleUpdateCategories = this.handleUpdateCategories.bind(this);
        this.getCategoryIDS = this.getCategoryIDS.bind(this);
        this.refreshCategories = this.refreshCategories.bind(this);
        this.displayName = 'CategoryPanel';
        this.state = {
            newCategory : null,
            selectedCategories : []
        }
    }

    componentDidMount() {
        console.log("CategoryPanel did mount.");
        this.handleUpdateCategories();
    }
    //Gets category pushes it onto the state.
    add(category) {
        var selectedCategories = [];

        if(this.props.post.categories && typeof this.props.post.categories !=='undefined')
            selectedCategories = this.props.post.categories.slice();

        selectedCategories.push(category);

        this.props.updatePostCategories(selectedCategories);
    }

    remove(category) {
        var sLength = this.props.post.categories.length;
        var sCats = this.props.post.categories;
        var newSCats = [];
        if(sLength > 1) {
            for (var i = 0; i < sLength; i++) {
                if(sCats[i] == category)
                {
                    var first = sCats.slice(0,i);
                    var second = sCats.slice(i+1,sLength);
                    newSCats = first.concat(second);
                }
            };
        }
        this.props.updatePostCategories(newSCats);
    }

    handleNewCategoryChange(e) {
        var value = e.target.value;
        if(value != '')
            this.setState({
                newCategory : value
            })
        else
            this.setState({
                newCategory : null
            })
    }
    handleAddCategory() {
        var component = this;
        var category = this.state.newCategory;
        var conn = this.props.connection;

        if(category)
            this.handleCreateCategory(category)
        else
            console.log("No category to add.");
    }

    handleCreateCategory(category) {
        if(category) {
            var slug = (category.toLowerCase().match(/[a-z0-9\-]+/g)).join('-');

          Api
            .createCategory({
              name: category,
              slug
            })
            .then(data =>{
              this.handleUpdateCategories();
              this.props.notify({title: 'Success!', message: 'Category created.'},{type:'success'});
              this.setState({newCategory: ''});
            })
            .catch(e => this.props.notify({title: 'Error Creating Categories!',message : e.message}));
        }

    }

    handleUpdateCategories(data) {
      Api
        .fetchCategories()
        .then(this.refreshCategories)
        .catch(error => this.props.notify({message: error.message}));
    }
    refreshCategories(categories) {
        this.props.refreshCategories(categories);
        this.setState({newCategory : null});
    }
    getCategoryIDS(categories) {
        if(categories && typeof categories !== 'undefined'){
            var ids = [];
            for (var i = 0; i < categories.length; i++) {
                ids.push(categories[i]);
            };
            return ids;
        }
        return [];
    }
    render() {
        var newCategory = this.state.newCategory;
        // debugger;
        var selectedCategories = this.getCategoryIDS(this.props.post.categories);

        return (
        	<UI.Panel title="Categories">
        			<div className="row mb-lg">
	        			<div className="col-md-12">
		        			<div className="form-horizontal form-bordered">
		        				<MultiSelect options={this.props.categories} selected={selectedCategories} add={this.add} remove={this.remove} />
		        			</div>
		        		</div>
                    </div>
                    <div className="row">
		        		<div className="col-md-12">
                            <div className="input-group">
                            <input type="text" className="form-control" placeholder="Category Name" onChange={this.handleNewCategoryChange} value={newCategory} />
                            <span className="input-group-btn"><button onClick={this.handleAddCategory} className="btn btn-success">Add</button></span>
                            </div>
		        		</div>
        			</div>
            </UI.Panel>
        );
    }
}

var mapStateToProps = function(state) {
	return {
		connection : state.connection,
		categories : state.categories,
        post : state.post
	}
}

export default connect(mapStateToProps,Actions)(CategoryPanel);



// WEBPACK FOOTER //
// ./src/browser/components/categories/categoryPanel.js